<template>
	<div id='personalSettings'>
		<el-row>
			<el-col :span='24' class="personalSettings_title">个人设置</el-col>
		</el-row>
		<el-row>
			<div class='userAccount'>
				<span class="userAccount_span">登录账户</span>
				<el-input size='small' disabled v-model='userNumber'></el-input>
			</div>
			<span class="registerTime">注册时间：</span><span> {{createTime}}</span>
		</el-row>
		<el-row>
			<el-col :span='24' class='userName'>
				<span >当前账套姓名</span>
				<el-input size='small' disabled v-model='userName'></el-input>
				<!-- <i class='el-icon-edit userName_edit' title='点击修改昵称' @click='handleUserName'></i> -->
			</el-col>
			
		</el-row>
		<el-row>
			<el-col :span='24' class='userAccount'>
				<span class="userAccount_span">密码</span>
				<span class="loginTime">上次登录时间：</span><span class="color3">{{loginEndTime}}</span>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span='24' class='modifyButton'>
				<span>安全性高的密码可以使账号更安全，建议您设置8-18位数字和字母组合的密码</span>
				<div class='elButton_c'>
					<el-button class='elButton minButton' size='small'  @click='dialogVisible=true'>修改密码</el-button>
					<el-button class='elButton minButton' size='small'  @click='dialogVisibles=true'>修改手机号</el-button>
				</div>
			</el-col>
		</el-row>
		<!-- 修改手机号 -->
		<el-dialog
			:visible.sync='dialogVisibles'
			width='500px'
			class='default-dialog'
			:close-on-click-modal='false'
			:close-on-press-escape='false'
			title='修改手机号'
		>
			<el-form ref='form' :model='phoneForm' :rules='rules_phone' label-width='100px'>
				<el-form-item label='手机号：' prop='newLoginName'>
					<el-input v-model='phoneForm.newLoginName' size='small' placeholder='请输入新修改手机号' style='width: 240px;'></el-input>
				</el-form-item>
				<el-form-item label='验证码：' prop='code'>
					<div class='securityCode_s'>
						<el-input v-model='phoneForm.code' size='small' placeholder='请输入验证码' style='width: 140px;' ></el-input>
					<el-button size='small' class='minButton sendCode' @click='sendCode("9")' :disabled='isSendButtonDisabled' >{{ButtonText}}</el-button>
					</div>
				</el-form-item>
				<div class='form_footer'>
					<el-button class='minButton' size='small' @click='handleModify_p'>确认</el-button>
				</div>
			</el-form>
		</el-dialog>
		<!-- 修改密码 -->
		<el-dialog
			:visible.sync='dialogVisible'
			width='500px'
			class='default-dialog'
			:close-on-click-modal='false'
			:close-on-press-escape='false'
			title='修改密码'
		>
			<el-form ref='form' :model='form' :rules='rules' label-width='100px'>
				<el-form-item label='手机号：'>
					<el-input v-model='form.moble' size='small' placeholder='请输入手机号' style='width: 240px;' disabled></el-input>
				</el-form-item>
				<el-form-item label='验证码：' prop='securityCode'>
					<div class='securityCode_s'>
						<el-input v-model='form.securityCode' size='small' placeholder='请输入验证码' style='width: 140px;' ></el-input>
					<el-button size='small' class='minButton sendCode' @click='sendCode("3")' :disabled='isSendButtonDisabled' >{{ButtonText}}</el-button>
					</div>
				</el-form-item>
				<el-form-item label='新密码：' prop='newPwd'>
					<el-input v-model='form.newPwd' size='small' placeholder='请输入新密码' style='width: 240px;' type='password'></el-input>
					<div class="Strength" v-show='strength.weak'>
						<div class="Strength_text">弱</div><div class="Strength_color1"></div>
					</div>
					<div class="Strength" v-show='strength.secondary'>
						<div class="Strength_text">中</div><div class="Strength_color2"></div>
					</div>
					<div class="Strength" v-show='strength.strong'>
						<div class="Strength_text">强</div><div class="Strength_color3"></div>
					</div>
				</el-form-item>
				<el-form-item label='确认新密码：'>
					<el-input v-model='sureNewPwd' size='small' placeholder='请再次输入新密码' style='width: 240px;' type='password'></el-input>
				</el-form-item>
				<div class='form_footer'>
					<el-button class='minButton' size='small' @click='handleModify'>确认</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			const phoneControl = (rule,value,callback) =>{
				var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				if(!myreg.test(value)) {
					return callback(new Error('无效手机号!'))
				}else {
					callback();
				}
			}
			const passwordControl = (rule , value , callback)=> {
				value = value.replace(/\s*/g,"");
				if(!value) {
					this.strength.weak = false;
					this.strength.secondary = false;
					this.strength.strong = false;
					return callback(new Error('密码不能为空!'))
				}
				let regLength = /^.{6,12}$/;  // 验证长度
				let regNum = /^[0-9]*$/;     // 验证不能为纯数字
				let regLetterU = /^[A-Z0-9]+$/;     // 验证密码有大写字母和数字组合
				let regLetterL = /^[a-z0-9]+$/;     // 验证密码有小写字母和数字组合
				let regLetterLU = /^[a-zA-Z]+$/;     // 验证密码有小写字母组合
				let regAll = /^[A-Za-z0-9+-.!@#$%^&*_]+$/ // 随机组合
				let regLetter = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d]{6,}$/;     // 验证密码有大小写字母和数字组合
				let regMax = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[+-.!@#$%^&*_])[a-zA-Z\d+-.!@#$%^&*_]{10,}$/;// 大小写字母和数字、特殊字符组合
				if(!regLength.test(value)) {
					this.strength.weak = false;
					this.strength.secondary = false;
					this.strength.strong = false;
					return callback(new Error('密码长度为6-12位'))
				}
				if(regNum.test(value)) {
					this.strength.weak = false;
					this.strength.secondary = false;
					this.strength.strong = false;
					return callback(new Error('密码不能为纯数字'))
				}
				if(regLetterU.test(value) || regLetterL.test(value) || regLetterLU.test(value)) {
					this.strength.secondary = false;
					this.strength.weak = true;
					this.strength.strong = false;
					return callback();
				}else if(regLetter.test(value)) {
					this.strength.weak = true;
					this.strength.secondary = true;
					this.strength.strong = false;
					return callback();
				}else if(regMax.test(value)) {
					this.strength.weak = true;
					this.strength.secondary = true;
					this.strength.strong = true;
					return callback();
				}else if(regAll.test(value)){
					this.strength.weak = true;
					this.strength.secondary = true;
					this.strength.strong = false;
					return callback();
				}else  {
					this.strength.weak = false;
					this.strength.secondary = false;
					this.strength.strong = false;
					return callback(new Error('包含敏感字符!'))
				}
			}

			return {
				dialogVisibles:false,
				strength: {   // 验证强度显示控制
					weak: false,
					secondary: false,
					strong: false,
				},
				isSendButtonDisabled: false,    // 是否禁用发送按钮
				eldierUserName: false, // 修改姓名刷新控制
				ButtonText: '发送验证码', // 验证码按钮文字
				sureNewPwd: '',    // 确认新密码
				userNumber: '',
				createTime: '' , // 注册时间
				loginEndTime: '' , // 最后登录时间
				userName: '',
				dialogVisible: false,
				form: {
					moble: '', // 手机号码
					securityCode: '',  // 验证码
					newPwd: '',      // 新密码
				},
				phoneForm: {
					newLoginName: '', // 手机号码
					code: '',  // 验证码
				},
				rules_phone:{
					newLoginName:[
						{required: true, validator:phoneControl }
					],
					code:[{
						required: true, message: '验证码不能为空！' 
					}]
				},
				rules: {
					securityCode:[{
						required: true, message: '验证码不能为空！' 
					}],
					newPwd:[{
						required: true, validator: passwordControl 
					}]
				},

			}
		},
		created() {
			this.getUserMessage();
		},
		methods:　{
			// 修改昵称
			// handleUserName() {
			// 	this.$prompt('请输入长度为1-15字符', '修改昵称', {
		 //          confirmButtonText: '确定',
		 //          cancelButtonText: '取消',
		 //          inputPattern: /^\S{1,15}$/,
		 //          inputErrorMessage: '昵称不符合规范哟!'
		 //        }).then(({ value }) => {
		 //          try {
			// 			this.$http.post('sys/account/updName' , {name: value}).then(res=>{
			// 				if(res && res.data.code==1) {
			// 					this.eldierUserName = true;
			// 					this.getUserMessage();
			// 					 this.$message({
			// 			            type: 'success',
			// 			            message: res.data.msg
			// 			          }); 
			// 				}
			// 			})
			// 		}catch(e) {

			// 		}
		 //        }).catch(() => {
		 //          this.$message({
		 //            type: 'warning',
		 //            message: '已为您取消修改！'
		 //          });       
		 //        });
			// },
			// 获取用户信息
			getUserMessage() {
				this.$http.post('sys/account/getAccountInfo',{}).then(res=>{
					if(res && res.data.code == 1) {
						this.form.moble = res.data.data.loginName;
						this.userNumber = res.data.data.loginName;
						this.createTime = res.data.data.createTime;
						this.loginEndTime = res.data.data.loginEndTime;
						this.userName = res.data.data.name;
            this.$setSessionStorage("userMssage_name", res.data.data.name || res.data.data.loginName)
						this.$setSessionStorage('userMssage_number',res.data.data.loginName);
						if(this.eldierUserName) {
							this.eldierUserName = false;
							this.refreshSelectedTag();
						}
					}
				})
			},
			// 刷新/重载
			refreshSelectedTag () {
				let NewPage = '_empty' + '?time=' + new Date().getTime()/500;
			    this.$router.push(NewPage);
			    this.$router.go(-1);
			},
			// 点击获取验证码按钮
			sendCode(type) {
				var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				let phone = type==3?this.form.moble:this.phoneForm.newLoginName;
				console.log(phone)
				if(!myreg.test(phone)) {
					return this.$message.error("无效的手机号码！")
				}
				sessionStorage.setItem('sendCodeTime'+ phone,new Date().getTime())
				this.sendCodes(type);
				this.timer(60);
			},
			// 发送验证码
			sendCodes(type) {

				let params = {
					type: type,
					mobile: type==3?this.form.moble:this.phoneForm.newLoginName,
				}
				this.$http.post('sys/sendMessage/sendSms',params).then(res=>{
					if(res && res.data.code == 1) {
						this.$message({
				            type: 'success',
				            message: '发送成功!'
				          });
					}
				})
			},
			// 定时器
			timer(_wait) {
				let _ = this;
				let wait = _wait;
				if(wait<10) {
					wait = '0'+wait
				}
				if(wait == 0) {
					_.isSendButtonDisabled = false;
					_.ButtonText = '发送验证码';
				}else {
					_.isSendButtonDisabled = true;
					_.ButtonText = wait + 's';
					wait--;
					setTimeout(function() {
                        _.timer(wait);
                    },1000);
				}
			},
			// 修改手机号
			handleModify_p() {
				this.$http.post('sys/account/changeLoginName' , this.phoneForm).then(res=>{
					if(res && res.data.code == 1) {
						this.$message({
				            type: 'success',
				            message: '修改成功!'
				          });
						sessionStorage.clear();
						this.$router.push({
							path: '/login'
						})
					}
				})
			},
			// 修改密码
			handleModify() {
				if(this.sureNewPwd !== this.form.newPwd) {
					return this.$message.error('两次输入密码不一致！')
				}
				this.$refs.form.validate((valid)=>{
					if(valid) {
						this.$confirm('修改密码成功后将会退出登录，请及时保存数据, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
				        	this.$http.post('sys/account/changePwd' , this.form).then(res=>{
								if(res && res.data.code == 1) {
									this.$message({
							            type: 'success',
							            message: '修改成功!'
							          });
									sessionStorage.clear();
									this.$router.push({
										path: '/login'
									})
								}
							})
				        }).catch(() => {
				          this.$message({
				            type: 'warning',
				            message: '已取消密码修改'
				          });          
				        });
					}
				})
			},
		},
		watch: {
			dialogVisible(val) {
				if(val){
					let time =sessionStorage.getItem("sendCodeTime"+ this.form.moble);
					if(time){
						let now = new Date().getTime();
						if(now-time<60000){//如果小于一分钟
							this.timer((60-(now-time)/1000).toFixed(0));
						}
					}
					this.$nextTick(()=>{

						this.$refs['form'].resetFields();
						
					})
				}
			}
		}
	}
</script>
<style lang = 'less' scoped>
	#personalSettings {
		padding: 20px 30px 40px;
		background-color: #fff;
   		border-radius: 5px;
   		/*box-sizing: border-box;*/
   		.color3 {
   			color: #333;
   		}
   		.color6 {
   			color: #333;
   		}
   		.securityCode_s {
   			width: 240px;
   			display: flex;
   			align-items: center;
   			justify-content: space-between;
   		}
   		.userName_edit {
   			 margin-left: 10px; 
   			 cursor: pointer;
   			 &:hover{
   			 	color:#269D7B;
   			 };
   		}
   		.personalSettings_title {
   			display: block;
   			padding-bottom: 30px;
   			font-size: 30px;
   			font-weight:500;
   			color: #333;
   		}
   		.userAccount {
   			display: inline-block;
   			color: #666;
   			.userAccount_span {
   				display: inline-block;
   				margin-right: 20px;
   				width: 100px;
   				text-align: right;
   			}
   			.el-input {
   				width: 250px;
   				height: 32px;
   				margin: 0 100px 0 0px;
   			}
   		}
   		.registerTime {
   			color: #666;
   			margin-right: 10px;
   		}
   		.loginTime {
   			margin-right: 10px;
   			color: #333;
   		}
   		.userName {
   			margin: 30px 0;
   			span {
   				color: #666;
   				text-align: right;
   				display: inline-block;
   				width: 100px;
   			}
   			.el-input {
   				width: 250px;
   				height: 32px;
   				margin-left: 20px;
   			}
   		}
   		.modifyButton {
   			padding: 15px 0 0 90px;
   			span {
   				color: #999;
   				font-size: 12px;
   			}
   			.elButton_c {
   				display: inline-block;
   				margin-left: 250px;
   				.elButton {
   					width: 122px;
   					margin-left: 30px;
   				}
   				
   			}
   		}
   		.form_footer {
   			text-align: center;
   			.el-button {
   				width: 112px;
   				margin-top: 30px;
   			}
   		}
   		.sendCode {
   			display: inline-block;
   			width: 92px;
   		}
   		.Strength {
   			display: inline-block;
   			vertical-align: top;
   			text-align: center;
   			color: #666;
   			padding: 0 7px;
   			.Strength_color1 {
   				width: 20px;
   				height: 5px;
   				background:red; 
   				border-radius: 5px;
   			}
   			.Strength_color2 {
   				width: 20px;
   				height: 5px;
   				background:orange; 
   				border-radius: 5px;
   			}
   			.Strength_color3 {
   				width: 20px;
   				height: 5px;
   				background:yellowgreen; 
   				border-radius: 5px;
   			}
   			.Strength_text {

   			}
   		}
   		
	}
</style>


// WEBPACK FOOTER //
// src/pages/personalSettings.vue